import React, { memo } from 'react'

import { SectionItem } from '../sectionItem'
import { SkillItem } from '../skillItem'

import styles from './mySkill.module.scss'

function MySkill() {
  return (
    <SectionItem topic="SKILL">
      <div className={styles.skill__wrapper}>
        <SkillItem iconSrc="images/react-logo.svg" />
        <SkillItem iconSrc="images/angular-logo.svg" />
        <SkillItem iconSrc="images/go-logo-blue.svg" />
        <SkillItem iconSrc="images/jest-outline.svg" />
        <SkillItem iconSrc="images/redux-logo.svg" />
        <SkillItem iconSrc="images/logo-small.gif" />
        <SkillItem iconSrc="images/node-logo.png" />
      </div>
    </SectionItem>
  )
}

export default memo(MySkill)
